export const CREATE_DATABASE = 'workspace.create_database';
